import React from 'react';
import '../../styles/Homepage.css';
import '../../styles/Fonts.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const OurServices = () => {
  return (
    <section className="about-preview-section">
      <div className="container">
        <div className="about-content-wrapper">
          <div className="about-text-content">
            <div className="section-badge">WHAT WE DO</div>
            <h2 className="section-title">Our Services</h2>
            <p className="section-description">
              RCS Logistics Philippines offers comprehensive logistics solutions across multiple service areas, 
              ensuring your cargo reaches its destination safely and efficiently.
            </p>
            
          </div>
          <div className="about-image-content">
            <div className="about-stats">
              <div className="stat-item">
                <span className="stat-number">Track & Trace</span>
                <div className="stat-label">Real-time monitoring</div>
              </div>
              <div className="stat-item">
                <span className="stat-number">Transport</span>
                <div className="stat-label">Reliable delivery</div>
              </div>
              <div className="stat-item">
                <span className="stat-number">Forwarding</span>
                <div className="stat-label">Global network</div>
              </div>
              <div className="stat-item">
                <span className="stat-number">Brokerage</span>
                <div className="stat-label">Customs expertise</div>
              </div>
              <div className="stat-item">
                <span className="stat-number">Project Cargo</span>
                <div className="stat-label">Specialized handling</div>
              </div>
              <div className="stat-item">
                <span className="stat-number">Sea & Land</span>
                <div className="stat-label">Multi-modal solutions</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurServices;